import { LayoutType, withLayout } from 'src/hocs/withLayout'

import { CarePartners } from './carePartners'

const WrappedCarePartners = withLayout(LayoutType.NoPadding, CarePartners)

export { WrappedCarePartners as CarePartners }
